<template>
  <div class="small">
    <pie-chart
      v-if="showChart"
      :styles="{height: '200px'}"
      :chart-data="datacollection"
      :options="chartOptions"
    />
    <div
      v-else
      class="chart-widget-blank d-flex flex-column align-items-center justify-content-center mt-5"
    >
      <div class="mt-2">
        <i
          class="far fa-chart-pie-alt fa-3x"
          aria-hidden="true"
        />
      </div>
      <span class="text-center mt-4">
        {{ $t('dashboard.widget.pendingCasesEmptyStateText') }}
      </span>
    </div>
  </div>
</template>

<script>
import PieChart from './PieChart.js'
import dashboardService, { DASHBOARD_SITUATION_CASE_OPTIONS } from '@/api/resources/dashboard/dashboardService'
import Encoder from '@/utils/encoder'

export default {
    components: {
        PieChart
    },
    props: {
        laboratoriesId: { type: Array },
        casetypesId: { type: Array },
        caseSituation: { type: Object }
    },
    data() {
        return {
            datacollection: null,
            chartOptions: null,
            priorityData: [],
            encoder: new Encoder(),
            labels: [],
            data: [],
            backgroundColor: []
        }
    },
    computed: {
        showChart() {
            return this.datacollection?.datasets?.[0]?.data?.reduce((a, b) => a + b, 0) !== 0
        }
    },
    mounted() {
        this.fillData()
        this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            }
        }
    },
    methods: {
        async fillData() {
            this.clearFields()
            const filter = {
                'laboratory.labId': {
                    'filterType': 'set',
                    'values': this.laboratoriesId.map(laboratory => laboratory.labId)
                },
                'caseType.id': {
                    'filterType': 'set',
                    'values': this.casetypesId.map(caseType => caseType.id)
                }
            }
            const caseSituation = this.caseSituation ? this.caseSituation.key : DASHBOARD_SITUATION_CASE_OPTIONS.ALL_PENDING_DASHBOARD.key
            this.updateLoading(true)
            const [error, response] = await this.toCall(dashboardService.getSummaryCaseByPriority(caseSituation, filter))
            this.priorityData = response
            if (error) {
                this.showErrorModalGlobal()
                this.updateLoading(false)
                return
            }
            Object.keys(this.priorityData).forEach(key => {
                this.labels.push(this.priorityData[key].entity.name)
                this.data.push(this.priorityData[key].count)
                this.backgroundColor.push(this.priorityData[key].entity.color)
            }
            )
            this.datacollection = {
                labels: this.labels,
                datasets: [
                    {
                        label: 'Data 1',
                        backgroundColor: this.backgroundColor,
                        data: this.data
                    }
                ]
            }
            this.updateLoading(false)
        },
        clearFields() {
            this.labels = []
            this.data = []
            this.backgroundColor = []
        }
    }
}
</script>

<style>
</style>
